import { render, staticRenderFns } from "./editInterview.vue?vue&type=template&id=4580c80c&scoped=true&"
import script from "./editInterview.vue?vue&type=script&lang=js&"
export * from "./editInterview.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/interview/editInterview.less?vue&type=style&index=0&id=4580c80c&lang=less&scoped=true&"
import style1 from "./editInterview.vue?vue&type=style&index=1&id=4580c80c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4580c80c",
  null
  
)

component.options.__file = "editInterview.vue"
export default component.exports